import { IsDefined, IsString } from 'class-validator';

export class GetExternalAuthTokenResponse {
    @IsDefined()
    @IsString()
    public token: string;

    constructor(data?: Partial<GetExternalAuthTokenResponse>) {
        this.token = data?.token;
    }
}
